import { UnknownAction } from "redux";
import { isLanguagesAction } from "../actions/Languages.js";
import { Language } from "../types/index.js";

const initialState: Language[] = [];

const getLanguagesSuccess = (languages: Language[]) => {
  return languages;
};

const reducer = (state = initialState, action: UnknownAction) => {
  if (!isLanguagesAction(action)) {
    return state;
  }

  switch (action.type) {
    case "GET_LANGUAGES_SUCCESS":
      return getLanguagesSuccess(action.languages);

    default:
      return state;
  }
};

export default reducer;
